import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
	Modal,
	Logo,
	HeadingBox,
	Dropdown,
	DialogHandler,
} from "cakemail-ui-components/lib/react";
import { bindActionCreators } from "redux";
import { I18n, Translate } from "react-redux-i18n";
import { getLanguagesOptions, setLocaleWithFallback } from "utils/languages";
import { updateUserService } from "assets/js/services/userService";

function NoMobile(props) {
	function handleLocaleChange(e, input, option) {
		updateUserService(
			{
				id: props.user.id,
				user: { language: option.value },
			},
			() => {},
			() => {
				DialogHandler.show({
					type: "error",
					title: <Translate value="app-settings-update-error" />,
				});
			}
		);

		props.setLocaleWithFallback(option.value);
	}

	let languageList = null;

	if (props.language) {
		languageList = getLanguagesOptions(props.language);
	}

	return (
		<Modal
			className="mobileNotSupported"
			topBarLeft={<Logo url={props.logo} />}
			topBarRight={
				<>
					{languageList && (
						<Dropdown
							type="custom"
							options={languageList}
							shapeSytle="borderless"
							onChange={handleLocaleChange}
						/>
					)}
				</>
			}
		>
			<HeadingBox
				title={
					<h2>
						<Translate value="app-mobile-unsupported-title" />
					</h2>
				}
				text={
					<>
						<p>
							<Translate value="app-mobile-unsupported-desc" />
						</p>
						<p>
							<b>
								<Translate
									value="app-mobile-unsupported-thank-you"
									name={props.user?.first_name}
									resellerName={props.resellerName}
								/>
							</b>
						</p>
						<a href="#" onClick={props.logOut}>
							<Translate value="app-menu-list-sign_out" />
						</a>
					</>
				}
			/>
		</Modal>
	);
}

NoMobile.propTypes = {
	logo: PropTypes.string,
	user: PropTypes.object,
	logOut: PropTypes.func,
	language: PropTypes.string,
	setLocaleWithFallback: PropTypes.func,
	resellerName: PropTypes.string,
};

export default withRouter(
	connect(
		(state) => {
			return {
				logo: state.brand?.images["logo"],
				user: state.global.user,
				language: state.global.language,
				resellerName: state.brand?.name,
			};
		},
		(dispatch) =>
			bindActionCreators(
				{
					setLocaleWithFallback,
				},
				dispatch
			)
	)(NoMobile)
);
